export default __webpack_public_path__ + "static/media/icono-facebook.d205ec3e.svg";